import { AxiosInstance } from 'axios';
import { PaymentKind, YookassaPayment, YookassaPaymentDetail, YookassaPaymentStatus } from './types';

interface YookassaPaymentListRequest {
  page: number;
  pageSize: number;
  statuses?: YookassaPaymentStatus[];
  kind?: PaymentKind;
  fromDate?: string;
  toDate?: string;
  userEmailSearch?: string;
}

export function yookassaPaymentsApi(client: AxiosInstance) {
  return {
    getList: (req: YookassaPaymentListRequest) =>
      client.post<{ items: YookassaPayment[]; totalCount: number }>(
        '/api/v1/admin/yookassa-payments/get-list', req),
    getById: (id: number) =>
      client.post<YookassaPaymentDetail>('/api/v1/admin/yookassa-payments/get-by-id', { id }),
  };
}
